import { render, staticRenderFns } from "./AnnotationSimple.vue?vue&type=template&id=6ec4d0d6&scoped=true&"
import script from "./AnnotationSimple.vue?vue&type=script&lang=js&"
export * from "./AnnotationSimple.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec4d0d6",
  null
  
)

export default component.exports